import script from "./PaymentListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentListView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentListView.vue?vue&type=style&index=0&id=a98acba4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98acba4"]])

export default __exports__